import AlternateEmailIcon from '@mui/icons-material/AlternateEmail'
import CancelIcon from '@mui/icons-material/Cancel'
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import { Box } from '@mui/material'
import { TFileStatuses } from 'src/services/backend'
import theme from 'src/styles/theme'
import styled, { css } from 'styled-components'
import { TypographyComponent } from '../Typography'

export const ModalTitle = styled(TypographyComponent)(
  () => css`
    && {
      font-size: ${theme.typograph.fontsize.h9};
      color: ${theme.colors.base.blue};
      font-weight: 700;

      @media (max-width: ${theme.screen.medium}) {
        font-size: ${theme.typograph.fontsize.h5};
      }
    }
  `
)

export const HelperText = styled(TypographyComponent)(
  () => css`
    && {
      color: ${theme.colors.error.main};
      font-size: ${theme.typograph.fontsize.h10};
    }
  `
)

export const MissingFile = styled('span')(
  () => css`
    color: red;
    font-size: 1.6rem;
    margin-top: 2rem;
  `
)
const handleColorType = (status?: TFileStatuses | 'Enviar') => {
  switch (status) {
    case 'Aprovado':
      return 'green'
    case 'Reprovado':
      return 'red'
    case 'Em analise':
      return theme.colors.primary.main
    default:
      'Enviar'
      return 'orange'
  }
}

interface IStatusProps {
  status?: TFileStatuses | 'Enviar'
}

export const Status = styled('div')<IStatusProps>(
  ({ status }) => css`
    display: flex;
    flex-direction: column;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 1.4rem;
    color: ${handleColorType(status)};
  `
)

export const CancelWarning = styled(CancelIcon)(
  ({ theme }) => css`
    && {
      color: ${theme.colors.warning.main};
      font-size: ${theme.typograph.fontsize.h6};
    }
  `
)

export const HourglassEmpty = styled(HourglassEmptyIcon)(
  ({ theme }) => css`
    && {
      font-size: ${theme.typograph.fontsize.h6};
    }
  `
)

export const Check = styled(CheckIcon)(
  () => css`
    && {
      font-size: ${theme.typograph.fontsize.h6};
    }
  `
)

export const Close = styled(CloseIcon)(
  () => css`
    && {
      font-size: ${theme.typograph.fontsize.h6};
    }
  `
)

export const Email = styled(AlternateEmailIcon)(
  ({ theme }) => css`
    && {
      font-size: ${theme.layout.iconSize.medium};
      width: ${theme.layout.iconSize.medium};
      height: ${theme.layout.iconSize.medium};
    }
  `
)

export const WhatsApp = styled(WhatsAppIcon)(
  ({ theme }) => css`
    && {
      font-size: ${theme.layout.iconSize.medium};
      width: ${theme.layout.iconSize.medium};
      height: ${theme.layout.iconSize.medium};
    }
  `
)

export const ModalBoxButtons = styled.div(
  () => css`
    display: flex;
    justify-content: flex-end;
    gap: ${theme.layout.gap.medium};
    margin-top: ${theme.layout.margin.base * 2}rem;
  `
)

export const BoxContainer = styled(Box)(
  ({ theme }) => css`
    position: absolute;
    top: 50%;
    left: 50%;
    width: 80%;
    height: 80%;
    overflow: auto;
    transform: translate(-50%, -50%);
    background-color: ${theme.colors.base.white};
    border-radius: ${theme.layout.borderRadius.medium};
    padding: ${theme.layout.padding.big};
  `
)

export const ContainerResponsible = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.layout.gap.big};
  `
)
